(function ($) {
	$('.scroll-to-top').on('click', function (e) {
		e.preventDefault();
		$("html, body").animate({ scrollTop: 0 }, 1000);

		// set focus to skip content link
		$(".nav-bypass").attr('tabindex', '-1').trigger('focus');
	});
})(jQuery);
